import format from "date-fns/format";
import frLocale from "date-fns/locale/fr";
import DateFnsUtils from "@date-io/date-fns";
import React, { useState, useCallback } from "react";
import { IconButton, Menu, MenuItem } from "@material-ui/core";
import { KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";

const DatePickeur = (props) => {
  const [selectedDate, handleDateChange] = useState(props.value || null);

  const valueChangeHandler = (value) => {
    handleDateChange(value);
    props.onChange(value);
  };


  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils} locale={frLocale}>
      <KeyboardDatePicker disableFuture={true} cancelLabel="Annuler" clearLabel="Effacer" clearable 
        value={selectedDate}
        onChange={valueChangeHandler}
        onBlur={props.touchHandler}
        format={"d MMM yyyy"}
        emptyLabel={""}
        />
    </MuiPickersUtilsProvider>
  );
};

export default DatePickeur;
